import { render, staticRenderFns } from "./Report-Assets.vue?vue&type=template&id=2106f7f4&scoped=true&"
import script from "./Report-Assets.vue?vue&type=script&lang=js&"
export * from "./Report-Assets.vue?vue&type=script&lang=js&"
import style0 from "./Report-Assets.vue?vue&type=style&index=0&id=2106f7f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106f7f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
